<template>
  <div class="wrapper">
    <!-- 适老化改造 -->
    <!-- <vxe-toolbar>
			<template v-slot:buttons>
				<vxe-button status="my-orange" @click="showSearch(false)" v-if="seachStatus">隐藏查询</vxe-button>
				<vxe-button status="my-orange" icon="fa fa-search" @click="showSearch(true)" v-if="!seachStatus">查询</vxe-button>
				<vxe-button status="my-orange" icon="" @click="goPage('add')">下载报告</vxe-button>
			</template>
		</vxe-toolbar>-->
    <div>
      <vxe-button status="my-orange" icon="fa fa-plus" @click="addProduct()">添加</vxe-button>
      <vxe-button status="my-orange" icon="fa fa-plus" @click="importData">导入</vxe-button>
      <!--      <vxe-button status="my-orange" icon="fa fa-plus" @click="exportData">导出</vxe-button>-->
    </div>
    <div style="margin-top: 20px">
      <el-table :data="tableData" border show-overflow-tooltip style="width: 100%">
        <el-table-column align="center" prop="categoryLevel1" label="项目类别"/>
        <el-table-column align="center" prop="category" label="图片">
          <template slot-scope="{row}">
            <CustomPic v-if="row.pictureList != null" :src="row.pictureList[0].url" :src-list="row.pictureListArray"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="model" label="型号"/>
        <el-table-column align="center" prop="name" label="名称"/>
        <el-table-column align="center" prop="parameter" label="参数"/>
        <el-table-column align="center" prop="func" label="功能"/>
        <el-table-column align="center" prop="price" label="质检报告">
          <template slot-scope="{row}">
            <CustomPic v-if="row.qualityInspectReportList != null" :src="row.qualityInspectReportList[0].url"
                       :src-list="row.qualityInspectReportListArray"/>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="manufacturer" label="厂家"/>
        <el-table-column align="center" prop="price" label="单价/元" show-overflow-tooltip/>
        <el-table-column align="center" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="editClick(scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="delproduct(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="page">
      <vxe-pager
          :current-page.sync="tablePage.currentPage"
          :page-size.sync="tablePage.pageSize"
          :page-sizes="tablePage.pageSizes"
          :total="tablePage.totalResult"
          :layouts="layouts"
          @page-change="pageChange"
      />
    </div>

    <el-dialog title="添加适老化改造" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
      <el-form :model="form" label-position="left">

        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="一级类别" :label-width="formLabelWidth">
          <el-input v-model="form.categoryLevel1" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="二级类别" :label-width="formLabelWidth">
          <el-input v-model="form.categoryLevel2" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="功能" :label-width="formLabelWidth">
          <el-input v-model="form.func" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="厂家" :label-width="formLabelWidth">
          <el-input v-model="form.manufacturer" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="型号" :label-width="formLabelWidth">
          <el-input v-model="form.model" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="参数" :label-width="formLabelWidth">
          <el-input v-model="form.parameter" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-select v-model="form.state" filterable style="width:100%" placeholder="请选择状态">
            <el-option key="1" label="可用" :value="1"/>
            <el-option key="2" label="不可用" :value="2 "/>
          </el-select>
        </el-form-item>
        <el-form-item label="单价/元" :label-width="formLabelWidth">
          <el-input v-model="form.price" type="number" autocomplete="off"/>
        </el-form-item>
        <el-form-item label="产品图片" :label-width="formLabelWidth">
          <upload-img :limit="6" :upload-lists="pictureList" @uploadChange="onBeforeImg"/>
        </el-form-item>
        <el-form-item label="质检报告" :label-width="formLabelWidth">
          <upload-img :limit="6" :upload-lists="qualityInspectReportList" @uploadChange="onAfterImg"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="()=>{dialogFormVisible = false,form={},qualityInspectReportList=[],pictureList=[]}">取 消
        </el-button>
        <el-button type="primary" @click="addOrEdit()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
        v-loading="uploadLoading"
        element-loading-text="上传中，请勿关闭窗口或切换页面！"
        title="导入人员"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        width="35%"
    >
      <el-upload class="upload-demo" accept=".xlsx, .xls" action="" :before-upload="handleUpload">
        <el-button size="small" type="primary">点击上传</el-button>
      </el-upload>
      <div class="file-list">
        <p>{{ fileName }}</p>
      </div>
      <div>
        <p class="import-old-person-file">请选择文件小于5M且最多1000条数据的Excel</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="btndisabled" @click="importSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import UploadImg from '@/components/UploadImg.vue'
import axios from 'axios'
import api from '@/store/API/api'
import { default as CustomTemplate } from '@/components/CustomList/CustomTemplate'

export default {
  components: {
    UploadImg, ...CustomTemplate
  },
  data() {
    return {
      btndisabled: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      chooseId: '',
      form: [],
      pictureList: [],
      qualityInspectReportList: [],
      fileData: null,
      fileName: '',
      importVisible: false,
      uploadLoading: false,
      tableData: [],
      // ismore:false,
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true
      }
    }
  },
  created() {
    this.getLists()
  },
  computed: {
    ...mapState([
      'layouts'
    ])
  },
  methods: {
    ...mapActions([
      'getProductList',
      'productAdd',
      'productUpdate',
      'productDelete',
      'productDetail'
    ]),
    onBeforeImg(data) {
      this.form.pictures = data.join(',')
    },
    onAfterImg(data) {
      this.form.qualityInspectReports = data.join(',')
    },
    // 分页功能
    pageChange(item) {
      if (item.type === 'size') {
        this.tablePage.currentPage = 1
      } else {
        this.tablePage.currentPage = item.currentPage
      }
      this.getLists()
    },
    goPage(type, itemData) {
      this.$router.push({
        name: 'AddPerson',
        params: {
          type: type,
          id: itemData.oldPersonId
        },
        query: {
          oldPersonId: itemData.oldPersonId
        }
      })
    },
    // 查询列表
    getLists() {
      const params = {
        pageNum: this.tablePage.currentPage,
        pageSize: this.tablePage.pageSize
      }
      this.getProductList(params).then(res => {
        if (res.code === 200) {
          res.data.dataList.forEach(item => {
            const pictureListArray = []
            if (item.pictureList != null) {
              item.pictureList.forEach(picture => {
                pictureListArray.push(picture.url)
              })
            }
            item.pictureListArray = pictureListArray

            const qualityInspectReportListArray = []
            if (item.qualityInspectReportList != null) {
              item.qualityInspectReportList.forEach(qualityInspectReport => {
                pictureListArray.push(qualityInspectReport.url)
              })
            }
            item.qualityInspectReportListArray = qualityInspectReportListArray
          })
          this.tableData = res.data.dataList
          this.tablePage.totalResult = res.data.total
        }
      })
    },
    // 删除
    delproduct(row) {
      this.$XModal.confirm('您确定要删除该数据?').then(type => {
        if (type === 'confirm') {
          const params = row.id
          this.productDelete(params).then(res => {
            if (res.code === 200) {
              this.$message({
                type: 'success',
                message: '删除成功'
              })
              this.getLists()
            }
          })
        } else {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        }
      })
    },
    // 导入功能
    importData() {
      this.importVisible = true
    },
    handleUpload(file) {
      const suffix = file.name.split('.')[1]
      if (!['xlsx', 'xls'].includes(suffix)) {
        this.$XModal.message({
          message: '文件格式不正确',
          status: 'warning'
        })
        return false
      }
      const realFilesize = file.size / 1024 / 1023
      if (realFilesize > 5) {
        this.$XModal.message({
          message: '你选择的文件大于5M',
          status: 'warning'
        })
        return false
      }

      this.fileData = file
      this.fileName = file.name
      return false
    },
    importSubmit() {
      if (this.fileData) {
        this.btndisabled = true
        const formData = new FormData()

        formData.append('excelFile', this.fileData)
        // 上传中
        this.uploadLoading = true

        let url = process.env.NODE_ENV === 'development' ? '/api' : process.env.VUE_APP_BASEURL
        url += api.importHomeOldPerson
        axios({
          method: 'post',
          data: formData,
          url,
          timeout: 300000,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: sessionStorage.token
          }
        }).then((res) => {
          this.uploadLoading = false
          this.btndisabled = false
          if (res.data.code === 200) {
            this.uploadLoading = false
            this.$message.success('导入成功')
            this.importVisible = false
            this.getLists()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              showClose: true,
              duration: 0

            })
          }
        })
      } else {
        this.$XModal.message({
          message: '请上传模板文件',
          status: 'warning'
        })
      }
    },
    addProduct() {
      this.dialogFormVisible = true
      this.form = {}
      this.qualityInspectReportList = []
      this.pictureList = []
      this.chooseId = ''
    },
    editClick(row) {
      this.chooseId = row.id
      this.productDetail(this.chooseId).then(res => {
        if (res.code === 200) {
          this.dialogFormVisible = true
          this.form = {
            ...res.data
          }
          this.$nextTick(() => {
            this.pictureList = res.data.pictureList === null ? [] : res.data.pictureList
            this.qualityInspectReportList = res.data.qualityInspectReportList === null ? [] : res.data.qualityInspectReportList
          })
        }
      })
    },
    addOrEdit() {
      if (this.chooseId === '') {
        this.productAdd(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success('添加成功')
            this.form = {}
            this.dialogFormVisible = false
            this.getLists()
          }
        })
      } else {
        this.productUpdate(this.form).then(res => {
          if (res.code === 200) {
            this.$message.success('修改成功')
            this.form = {}
            this.dialogFormVisible = false
            this.getLists()
          }
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: auto;

  .page {
    overflow: initial;
  }
}

.w-100 {
  width: 100% !important;
}

v-deep .el-form-item__label {
  text-align: left !important;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
}
</style>
